import { useRef } from 'react';
import { defaultShapeUtils, TldrawEditor } from 'tldraw';
import { useMultiplayerSync } from '@/hooks/useMultiplayerSync';
import { useMeetingStore } from '@/stores/meeting';
import { getAssetUrlsByImport } from '@tldraw/assets/imports.vite';

const assetUrls = getAssetUrlsByImport();

interface CleanupWorkerProps {
  onDone: (id: string) => void;
  currentDeletingDocId: string;
}

export function CleanupWorker({ onDone, currentDeletingDocId }: CleanupWorkerProps) {
  const isProcessed = useRef(false);

  const meeting = useMeetingStore((state) => state.meeting);
  const roomId = `tldraw-meeting-pdf-${meeting?.uuid}-${meeting?.author_uuid}-${currentDeletingDocId}`;

  const syncResult = useMultiplayerSync(roomId);
  return (
    <div
      style={{
        position: 'absolute',
        opacity: 0,
        pointerEvents: 'none',
        zIndex: -9999,
        width: 1,
        height: 1,
        overflow: 'hidden'
      }}
    >
      {syncResult.status === 'synced-remote' && (
        <TldrawEditor
          assetUrls={assetUrls}
          store={syncResult.store}
          shapeUtils={defaultShapeUtils}
          onMount={(editor) => {
            if (isProcessed.current) return;
            isProcessed.current = true;

            const performCleanup = async () => {
              try {
                const shapes = editor.getCurrentPageShapes();
                const assets = editor.getAssets();

                editor.updateDocumentSettings({
                  meta: { ...editor.getDocumentSettings().meta, isFocused: false }
                });

                if (shapes.length > 0) {
                  editor.updateShapes(
                    shapes.map((s) => ({ id: s.id, type: s.type, isLocked: false }))
                  );
                  editor.deleteShapes(shapes.map((s) => s.id));
                }

                if (assets.length > 0) {
                  editor.deleteAssets(assets.map((a) => a.id));
                }

                setTimeout(() => {
                  onDone(currentDeletingDocId);
                }, 1000);
              } catch (e) {
                console.error(`Ошибка очистки ${currentDeletingDocId}:`, e);
                onDone(currentDeletingDocId);
              }
            };

            performCleanup();
          }}
        />
      )}
    </div>
  );
}

export default CleanupWorker;
